import { render } from "./BreadCrumbs.vue?vue&type=template&id=39541048&ts=true"
import script from "./BreadCrumbs.ts?vue&type=script&lang=ts"
export * from "./BreadCrumbs.ts?vue&type=script&lang=ts"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=39541048&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__